import * as Sentry from '@sentry/nextjs';
import { SENTRY_DSN } from '@src/constants';

let sentryInitialized = false;

export const initializeSentryClient = (env_name: string): void => {
	// Prevent multiple initializations
	if (sentryInitialized) {
		return;
	}
	const isProd = env_name === 'production' || env_name === 'prod';
	Sentry.init({
		dsn: SENTRY_DSN,

		// Add optional integrations for additional features
		integrations: [Sentry.replayIntegration(), Sentry.browserProfilingIntegration()],

		// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
		tracesSampleRate: isProd ? 0.1 : 1.0,

		// Set sampling rate for profiling
		// This is relative to tracesSampleRate
		profilesSampleRate: isProd ? 0.1 : 1.0,

		// Define how likely Replay events are sampled.
		// This sets the sample rate to be 10%. You may want this to be 100% while
		// in development and sample at a lower rate in production
		replaysSessionSampleRate: isProd ? 0.1 : 1.0,

		// Define how likely Replay events are sampled when an error occurs.
		replaysOnErrorSampleRate: isProd ? 0.1 : 1.0,

		// Setting this option to true will print useful information to the console while you're setting up Sentry.
		debug: !isProd,
		environment: env_name,
	});
	sentryInitialized = true;
};
